module.exports = __webpack_public_path__ + "media/story_video.814d7a78.mp4";